import axios from "../utils/axios";

function request(functionId, body) {
  let data = {
    functionId,
    body
  };
  return axios.request({
    data: data,
    method: "post"
  });
}

// 导入
export function exportExcel(body) {
  return request("health_cmp_biz_exportExcel", body);
}
